"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findHotProbsMarketsOutcomesIds = findHotProbsMarketsOutcomesIds;
const constants_1 = require("../../containers/CommonDataProvider/constants");
const keyBy_1 = __importDefault(require("../functions/keyBy"));
const mapValues_1 = __importDefault(require("../functions/mapValues"));
function findHotProbsMarketsOutcomesIds(outcomeTypes, hotProbsMap = constants_1.HOT_PROBS_MARKETS_OUTCOMES_MAP) {
    const codeToIdMap = (0, keyBy_1.default)(outcomeTypes, 'code');
    const result = (0, mapValues_1.default)(hotProbsMap, (item) => item.map((i) => { var _a; return (_a = codeToIdMap[i.mainOutcomeType]) === null || _a === void 0 ? void 0 : _a.id; }).filter(Boolean));
    return result;
}
//# sourceMappingURL=findHotProbsMarketsOutcomesIds.js.map